import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export class FormErrorsHelper {

  private static initializedControls = new WeakSet<AbstractControl>();

  static getFormGroupErrors(form: FormGroup): ValidationErrors | null {
    const errors: ValidationErrors = {};

    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);

      if (control instanceof FormGroup) {
        Object.assign(errors, this.getFormGroupErrors(control));
        return;
      }

      if (control && !this.initializedControls.has(control)) {
        control.valueChanges.subscribe(() => {
          if (control.dirty && !control.touched && control.value) {
            control.markAsTouched();
          }
        });

        this.initializedControls.add(control);
      }

      if (control && control.invalid && control.touched) {
        errors[key] = { ...control.errors, message: control.errors?.['message'] };
      }
    });

    if (Object.keys(errors).length) {
      return errors;
    }

    return null;
  }
}
